<script setup lang="ts">
withDefaults(
  defineProps<{
    /** The grey shell alone, with no 4px inset and no column layout, for content the caller lays out itself, such as an empty state. */
    bare?: boolean
    /** The shell's ground: `neutral` is the panel grey; `accent` washes it blue for a panel of Raldo's suggestions. */
    tone?: 'neutral' | 'accent'
    /** While something is dragged over it: `accept` washes the shell blue, `refuse` washes it red. */
    drop?: 'accept' | 'refuse' | null
  }>(),
  { bare: false, tone: 'neutral', drop: null },
)

defineSlots<{
  /** The panel's parts in order: `AppPanelRim` captions and `AppPanelBody` wells. */
  default(): unknown
}>()
</script>

<template>
  <section
    class="flex min-w-0 rounded-8 with-sticky-head:overflow-clip transition-colors duration-fast ease-soft motion-reduce:transition-none"
    :class="[
      drop === 'accept'
        ? 'bg-accent-blue-wash'
        : drop === 'refuse'
          ? 'bg-accent-red-wash'
          : tone === 'accent'
            ? 'bg-bg-surface-accent'
            : 'bg-bg-surface',
      bare ? '' : 'flex-col p-2',
    ]"
  >
    <slot />
  </section>
</template>
